import { apiErrorMessages } from '@/helpers/apiError';

import { apiClient } from './client';

export function uploadReturnCoverage (formData: FormData) {
  return apiClient.post('/billing/return-coverage/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function downloadReturnCoverageFeeAudit () {
  return apiClient.get('/billing/return-coverage/audit-non-usd-fees', {
    responseType: 'blob',
  });
}

export function getShopPlan (shopId: number | string) {
  return apiClient.get(`/${shopId}/billing/plan`);
}

/**
 * OffsetBillingUploadController throws validation failures with MessageBag JSON
 * stringified into the `message` field (string[][]). Prefer fixing upstream; until
 * then, parse that shape here rather than in the shared apiError helper.
 */
export function parseReturnCoverageUploadJsonMessage (message: string): string[] | null {
  const trimmed = message.trim();
  if (!trimmed.startsWith('[')) {
    return null;
  }

  try {
    const parsed: unknown = JSON.parse(trimmed);
    if (!Array.isArray(parsed)) {
      return null;
    }

    return parsed
      .flat()
      .filter((value): value is string => typeof value === 'string' && value.trim() !== '');
  } catch {
    return null;
  }
}

export function returnCoverageUploadErrorMessages (err: unknown): string[] {
  return apiErrorMessages(err, {
    fallback: 'Something went wrong.',
    parseMessage: parseReturnCoverageUploadJsonMessage,
  });
}
